<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="wiscard">
      <div class="card_left">
        <div class="phonenavbar">
          <span><i class="el-icon-arrow-left"></i> 返回</span>
          <i class="el-icon-more"></i>
        </div>
        <img :src="yqBackgroundUrl" class="top" id="schoolBgimg"
             v-if="showschoolBgimg" />
        <div class="schoolInfo">
          <img :src="yqIconUrl" v-if="yqIconUrl" id="yqIconUrl" />
          <span v-text="yqName"></span>
        </div>

        <p v-html="yqFunction"></p>
        <ul class="function">
          <ul>
            <li v-for="item in list" @click="showList" :data-id="item._key" :key="item._key">
              <img :data-id="item._key" :src="item.navigateIconStr" v-if="item.navigateIconStr" alt="">
              <img :data-id="item._key" :src="item.navigateIconUrl" v-else alt="">
              <span :data-id="item._key">{{item.navigateName}}</span>
            </li>
          </ul>
        </ul>
      </div>
      <div class="card_right">
        <div class="step">
          <div :class="{ step_on:configcard }">
            常规设置
            <div class="trans"></div>
          </div>
          <div :class="{ step_on:confignavbar }">
            模板栏设置
            <div class="trans2"></div>
          </div>
          <div :class="{ step_on:configsave }">保存发布</div>
        </div>
        <div class="media">
          <div class="media-left">
            <img class="media-object" src="../../../../assets/cue.png" alt="...">
          </div>
          <div class="media-body" v-html="mediatext">

          </div>
        </div>
        <!--configCard-->
        <div class="content" v-if="configcard">
          <h6>常规设置</h6>
          <div>
            <div>
              <div><b style="color: #FF0000;">*</b>图标设置：</div>
              <div style="margin-bottom: 10px;">
                <input id="upload2" name="file" accept="image/*" type="file"
                       @change="upData2" style="display: none;" />
                <a @click="upImg2" id="cardbg2" style="width: 80px;height: 80px;border: dashed 1px #D7D7D7;">
                  <b style="display: block;text-align: center;line-height: 60px;font-size: 24px;color: #97A8BE;">✚</b>
                  <p style="text-align: center;width: 100%;">点击上传图标</p>
                </a>
                <p>建议上传尺寸不小于40px*40px等边矩形图；支持格式：png，jpeg，jpg，小于2M;</p>
              </div>
            </div>
            <div>
              <div>卡背景设置：</div>
              <div>
                <div>
                  <input id="upload" name="file" accept="image/*" type="file"
                         @change="upData" style="display: none;" />
                  <a @click="upImg" id="cardbg">
                    <b>✚</b>
                    <p>点击上传背景图</p>
                  </a>
                  <p>建议上传尺寸不小于1020px*643px等边矩形图；支持格式：png，jpeg，jpg，小于2M;</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="next" @click="next()" v-if="configcard">下一步</a>
        <!--confignavbar-->
        <div class="contentB" v-if="confignavbar">
          <h6>
            <span>模板栏位设置</span>
            <a @click="del">删除</a>
          </h6>
          <div class="column">
            <!--<div class="column_img">-->
              <!--<input id="uploadColumnImg" name="file" accept="image/*" type="file"-->
                     <!--@change="upColumnData" style="display: none;" />-->
              <!--<a @click="upColumnImg" class="upConfigIcon">-->
                <!--<img :src="uploadColumnImage" id="peopleImg" v-if="columnImageState" />-->
                <!--<b v-if="!columnImageState">✚</b>-->
                <!--<p v-if="!columnImageState">点击上传图标</p>-->
              <!--</a>-->
            <!--</div>-->
            <div class="column_text">
              <p><label for="nav_name"><strong>*</strong>导航名称<input type="text"
                                                                    id="nav_name"
                                                                    v-model="navigateName"
                                                                    maxlength="10"></label><span
                v-html="navigateNamePrv" style="margin-top: 10px;"></span></p>
              <!--<p><label for="nav_info"><strong></strong>显示内容<input type="text"-->
                                                                   <!--id="nav_info"-->
                                                                   <!--v-model="contentB"-->
                                                                   <!--maxlength="10"></label><span-->
                <!--v-html="contentBPrv" style="margin-top: 10px;"></span></p>-->
              <p><label for="nav_url"><strong>*</strong>链接地址<input type="text"
                                                                   id="nav_url"
                                                                   v-model="url"
                                                                   maxlength="256"></label><span
                v-html="urlPrv" style="margin-top: 10px;"></span></p>
            </div>
          </div>
        </div>
        <div class="ope" v-if="confignavbar">
          <button class="add" @click="addOne">添加一项</button>
          <button class="nextB" @click="nextB()">下一步</button>
        </div>
        <!--configsave-->

        <p style="font-size: 12px;color: #a6a6a6;margin:-5px 10px;line-height: 24px;" v-if="configsave"><i class="iconfont el-icon-damai-tishi_fill" style="color: #00A0E6;vertical-align: sub;font-size: 22px;"></i>调整卡面文案展示字段，需重新领卡后生效</p>
        <img :src="codeImg" alt="" style="width: 300px;display: block;margin: 20px auto;">
        <!--<a class="save" @click="save" v-if="configsave">保存并生成二维码</a>-->

        <!--<canvas class="qrcode" ref="qrCodeUrl" id="creatCode">-->

        <!--</canvas>-->

      </div>
    </div>
  </div>
</template>

<script>
import {api} from '../../../api/ConfigCardWx'
import QrCodeWithLogo from 'qr-code-with-logo'
import {errorHandler} from '../../../../utils/errorHandler'
import {nError} from '../../../../utils/notice'
import $ from 'jquery'
import {getObjectURL} from '../../../../utils/toBase64'
import {pattern} from '../../../../utils/regular'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import {bus} from '../../../../utils/bus'

const defaultCheckList = ['园区介绍', '园区公告', '房源招商', '推荐有礼', '租金缴费', '电费缴纳', '物业缴费', '人员审批', '人员管理', '访客预约', '停车缴费', '车辆授权', '智慧预约', '申请员工卡', '园区住户', '申请三方卡']

export default {
  components: {Breadcrumb},
  name: 'config-card-wx',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '微信卡包管理'
      }],

      supportPay: '',
      supportAccessControl: '',
      supportFrontText: '',
      yqBackgroundStr: '',
      showSupport: false,
      list: [],
      cardA: {},
      groupTitle: '1',
      checkAll: false,
      isIndeterminate: true,

      paletteConfigList: [
        {
          code: 'S001',
          value: '园区介绍'
        },
        {
          code: 'S002',
          value: '园区公告'
        },
        {
          code: 'Z001',
          value: '房源招商'
        },
        {
          code: 'Z002',
          value: '推荐有礼'
        },
        {
          code: 'Z003',
          value: '租金缴费'
        },
        {
          code: 'Z004',
          value: '电费缴纳'
        },
        {
          code: 'Z005',
          value: '物业缴费'
        },
        {
          code: 'Y001',
          value: '人员审批'
        },
        {
          code: 'F004',
          value: '人员管理'
        },
        {
          code: 'Y002',
          value: '访客预约'
        },
        {
          code: 'Y003',
          value: '停车缴费'
        },
        {
          code: 'Y004',
          value: '智慧预约'
        },
        {
          code: 'Y005',
          value: '车辆授权'
        },
        {
          code: 'F001',
          value: '园区住户'
        },
        {
          code: 'F002',
          value: '申请员工卡'
        },
        {
          code: 'F003',
          value: '申请三方卡'
        },
        {
          code: 'F005',
          value: '我的照片'
        }
      ],

      uploadColumnImage: '',
      columnImageState: false,
      navigateIconId: '',
      navigateName: '',
      navigateNamePrv: '<span>不超过10个字</span>',
      contentB: '',
      contentBPrv: '<span>请选择分类</span>',
      url: '',
      urlPrv: '<span>不超过256位</span>',
      navState: true,
      id: '',
      card: {},
      codeSize: false,
      addModeList: [],
      yqIconUrl: '../../../assets/dmlogo.png',
      yqBackgroundUrl: '',
      yqName: '',
      yqFunction: '<span style="display:block;width:50%;text-align:center;border-right:1px solid #00A0E6">去付款</span><span style="display:block;width:50%;text-align:center;">刷门禁</span>',
      configcard: true,
      mediatext: '<span>此处设置电子园区卡模板基础属性，包括卡图标、卡背景图片等。</span>',
      confignavbar: false,
      configsave: false,
      fcmodeList: '',
      formName: '',
      formCode: '',
      formDepartmentName: '',
      formCardTypeName: '',

      codes: '',
      showschoolBgimg: false,
      showyqIconUrl: false,

      codeImg: ''
    }
  },
  created () {
    this.getWXCardBag()
    // this.getFieldList()
  },
  methods: {
    // 获取导航栏
    getFieldList () {
      this.$axios.post(api.getFieldList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let navigateList = res.data.data
            this.list = navigateList
          }
        })
        .catch(errorHandler('查询失败'))
    },

    // 获取卡背景
    getWXCardBag () {
      this.$axios.post(api.getWXCardBag, {})
        .then(res => {
        if (res.data.retCode === 1) {
          const data = res.data.data
          if (data.yqIconUrl) {
            this.showyqIconUrl = true
          } else {
            this.showyqIconUrl = false
          }
          this.yqIconUrl = data.yqIconUrl
          if (data.yqBackgroundUrl) {
            this.showschoolBgimg = true
          } else {
            this.showschoolBgimg = false
          }
          this.yqBackgroundUrl = data.yqBackgroundUrl
          this.yqName = data.yqName

          this.formName = data.formName
          this.formCode = data.formCode
          this.formDepartmentName = data.formEnterpriseName
          this.formCardTypeName = data.formCardTypeName
        }
      })
        .catch(errorHandler('获取卡背景图失败'))
    },

    handleCheckAllChange (val) {
      this.checkListA = val ? defaultCheckList : [];
      this.isIndeterminate = false
    },
    // 查询模板栏功能列表
    getCheckListA () {
      this.$axios.post(api.getShowNavigate, {})
        .then(res => {
          this.checkListA = []
          let codeStr = res.data.data
          if (codeStr) {
            this.paletteConfigList.map(v => {
              if (codeStr.indexOf(v.code) !== -1) {
                this.checkListA.push(v.value)
              }
            })
          }
        })
        .catch(errorHandler('查询模板栏功能列表失败'))
    },

    // 模板栏位设置完成
    nextB () {
      let checkListA = this.checkListA.join(',')
      let showNavigatesArr = []
      this.paletteConfigList.map(v => {
        if (checkListA.indexOf(v.value) !== -1) {
          showNavigatesArr.push(v.code)
        }
      })
      let showNavigates = showNavigatesArr.join(',')
      if (!this.navState) {
        return false
      }
      if (!this.navigateName && this.url) {
        this.navigateNamePrv = '<span style="color:red;">导航名称不能为空</span>'
        return false
      }
      if (!this.url && this.navigateName) {
        this.urlPrv = '<span style="color:red;">链接地址不能为空</span>'
        return false
      }
      if (!this.navigateName && !this.url) {
        this.navigateNamePrv = '<span>不超过10个字</span>'
        this.urlPrv = '<span>不超过256位</span>'
      }
      const setArr = []
      const listArr = this.list
      for (let k = 0; k < listArr.length; k++) {
        const objArr = {}
        objArr.navigateName = listArr[k].navigateName
        objArr.navigateIconId = listArr[k].navigateIconId
        objArr.navigateIconUrl = listArr[k].navigateIconUrl
        objArr.navigateIconStr = listArr[k].navigateIconStr
        objArr.groupTitle = listArr[k].groupTitle
        objArr.url = listArr[k].url
        setArr.push(objArr)
      }
      this.$axios.post(api.addNavigate, {
        'navigates': setArr,
        'showNavigates': showNavigates
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.$layer.toast({
              icon: 'icon-check',
              content: '配置成功',
              time: 1000
            })
            this.confignavbar = false
            this.configsave = true
            this.mediatext = '<div><h4 style="font-size: 14px;line-height: 28px;font-weight: 400;">1. 设置电子园区卡卡面文案信息。</h4><h4 style="font-size: 14px;line-height: 28px;font-weight: 400;">2. 点击保存卡模板并生成领卡二维码，打开手机微信扫码完成授权领卡。</h4></div>'
            this.$axios.post(api.getNavigateList, {})
              .then(res => {
                if (res.data.retCode === 1) {
                  this.list = res.data.data
                }
              }, function () {
                console.log('err')
              })
          }
        })
        .catch(errorHandler('请求错误'))
    },
    // 删除模板栏位
    del ($event) {
      if (!this.navigateName && !this.url) {
        this.$layer.toast({
          icon: 'icon-check',
          content: '请先选择删除项',
          time: 1000
        })
        return false
      } else {
        this.list.map((v, i) => {
          if (v._key.toString() === this.id.toString()) {
            this.list.splice(i, 1)
          }
        })
        this.listOnChange()
        this.uploadColumnImage = ''
        this.groupTitle = '1'
        this.navigateName = ''
        this.url = ''
        this.id = ''
        this.columnImageState = false
        this.$layer.toast({
          icon: 'icon-check',
          content: '删除成功',
          time: 1000
        })
      }
    },
    // 添加模板栏位
    addOne () {
      if (!this.uploadColumnImage) {
        nError('请选择图标')
        return false
      }
      if (!this.navState) {
        return false
      }
      if (this.id) {
        if (this.navigateName && this.url) {
          let Obj = {
            navigateIconId: this.navigateIconId,
            navigateName: this.navigateName,
            groupTitle: this.groupTitle,
            navigateIconUrl: '',
            navigateIconStr: '',
            url: this.url,
            _key: this.list.length
          }
          if (this.uploadColumnImage.indexOf('base64') === -1) {
            Obj.navigateIconId = this.navigateIconId
            Obj.navigateIconUrl = this.uploadColumnImage
          } else {
            Obj.navigateIconId = ''
            Obj.navigateIconStr = this.uploadColumnImage
          }
          this.addModeList.push(Obj)
          this.list.splice(this.id, 1, Obj)
          this.listOnChange()
          this.uploadColumnImage = ''
          this.groupTitle = '1'
          this.navigateName = ''
          this.url = ''
          this.navigateIconId = ''
          this.columnImageState = false
        } else if (!this.navigateName) {
          this.navigateNamePrv = '<span style="color:red;">导航名称不能为空</span>'
          return false
        } else if (!this.url) {
          this.urlPrv = '<span style="color:red;">链接地址不能为空</span>'
          return false
        }
      } else {
        if (this.navigateName && this.url) {
          var Obj = {}
          Obj.groupTitle = this.groupTitle
          Obj.navigateIconStr = this.uploadColumnImage
          Obj.navigateName = this.navigateName
          Obj.url = this.url
          Obj._key = this.list.length
          this.addModeList.push(Obj)
          this.list.push(Obj)
          this.listOnChange()
          this.uploadColumnImage = ''
          this.groupTitle = '1'
          this.navigateName = ''
          this.url = ''
          this.columnImageState = false
        } else if (!this.navigateName) {
          this.navigateNamePrv = '<span style="color:red;">导航名称不能为空</span>'
          return false
        } else if (!this.url) {
          this.urlPrv = '<span style="color:red;">链接地址不能为空</span>'
          return false
        }
      }
      this.id = ''
    },
    // 清楚图片占位
    clearFile () {
      let file = document.getElementById('uploadColumnImg')
      if (file.outerHTML) {
        file.outerHTML = file.outerHTML
      } else {
        file.value = ''
      }
    },
    showList ($event) {
      if (this.confignavbar) {
        const Id = $event.target.dataset.id
        this.navigateName = this.list[Id].navigateName
        if (this.list[Id].navigateIconStr) {
          this.uploadColumnImage = this.list[Id].navigateIconStr
        } else {
          this.uploadColumnImage = this.list[Id].navigateIconUrl
        }
        this.navigateIconId = this.list[Id].navigateIconId
        this.id = Id
        this.url = this.list[Id].url
        this.columnImageState = true
      }
    },
    upImg () {
      let that = this
      $('#upload')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          const objUrl = getObjectURL(this.files[0]) // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            // $("#cardbg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            that.showschoolBgimg = true
            $('#schoolBgimg').attr('src', objUrl)
            window.sessionStorage.setItem('img', objUrl)
          }
        })
    },

    upData: function () {
      let that = this
      const oFReader = new FileReader()
      const file = document.getElementById('upload').files[0]
      // console.log(document.getElementById('upload').files[0])
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        // $('#cardbg').attr('src', src);
        that.showschoolBgimg = true
        $('#schoolBgimg').attr('src', src)
        that.yqBackgroundStr = src
      }
    },

    upImg2 () {
      let that = this
      $('#upload2')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          const objUrl = getObjectURL(this.files[0]) // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            // $("#cardbg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            // that.showschoolBgimg = true
            that.yqIconUrl = src
            that.yqIconStr = src
            $('#yqIconUrl').attr('src', objUrl)
            window.sessionStorage.setItem('img2', objUrl)
          }
        })
    },

    upData2: function () {
      let that = this
      const oFReader = new FileReader()
      const file = document.getElementById('upload2').files[0]
      // console.log(document.getElementById('upload').files[0])
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        // $('#cardbg').attr('src', src);
        // that.showschoolBgimg = true
        that.yqIconUrl = src
        $('#yqIconUrl').attr('src', src)
        that.yqIconStr = src
      }
    },
    // 常规设置完成
    next () {
      // const card = this.cardA
      // card.supportPay = this.supportPay
      // card.supportAccessControl = this.supportAccessControl
      // const str = JSON.stringify(card)
      // window.sessionStorage.setItem('card', str)
      this.$axios.post(api.addImage, {
        // 'supportPay': this.supportPay,
        // 'supportAccessControl': this.supportAccessControl,
        yqIconStr: this.yqIconStr,
        yqBackgroundStr: this.yqBackgroundStr
      }).then(res => {
        if (res.data.retCode === 1) {
          this.$layer.toast({
            icon: 'icon-check',
            content: '配置成功',
            time: 1000
          })
          // this.yqBackgroundUrl = this.yqBackgroundStr
          this.configcard = false
          this.configsave = true
          // this.confignavbar = true
          // this.mediatext = '<span>此处设置电子园区卡模板栏自定义栏位的功能点。</span>'
          this.mediatext = '<div><h4 style="font-size: 14px;line-height: 28px;font-weight: 400;">1. 设置电子园区卡卡面文案信息。</h4><h4 style="font-size: 14px;line-height: 28px;font-weight: 400;">2. 点击保存卡模板并生成领卡二维码，打开手机微信扫码完成授权领卡。</h4></div>'
          this.save()
        }
      })
        .catch(errorHandler('请求错误'))
    },
    upColumnImg () {
      this.clearFile()
      let that = this
      $('#uploadColumnImg')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          const objUrl = getObjectURL(this.files[0]) // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            // $("#cardbg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            that.columnImageState = true
            window.sessionStorage.setItem('columnImg', objUrl)
            that.upColumnData()
          }
        })
    },

    upColumnData () {
      let that = this
      const oFReader = new FileReader()
      const file = document.getElementById('uploadColumnImg').files[0]
      // console.log(document.getElementById('upload').files[0])
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        // $('#cardbg').attr('src', src);
        that.columnImageState = true
        that.uploadColumnImage = src
      }
    },
    // 保存发布并生成二维码
    save () {
      this.$axios.post(api.deleteNavigateByCodes, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.codeImg = res.data.data
          }
        })
        .catch(errorHandler('添加卡包失败'))
    }
  },
  watch: {
    cardTypeCode () {
      this.getCardBag()
      this.getCheckListA()
      this.getNavigateList()
    },
    confignavbar (Val) {
      const trans = document.getElementsByClassName('trans')
      const trans2 = document.getElementsByClassName('trans2')
      if (Val === true) {
        trans[0].style.backgroundColor = 'rgb(239,241,245)'
        trans2[0].style.backgroundColor = 'rgb(0,160,230)'
      }
    },
    configsave (Val) {
      const trans = document.getElementsByClassName('trans')
      const trans2 = document.getElementsByClassName('trans2')
      if (Val === true) {
        trans[0].style.backgroundColor = 'rgb(239,241,245)'
        trans2[0].style.backgroundColor = 'rgb(239,241,245)'
      }
    },

    navigateName (Val) {
      if (Val) {
        const atn = pattern.nav
        let flag = atn.test(Val)
        if (!flag) {
          this.navigateNamePrv = '<span style="color: red">名称由中文、字母、数字、下划线组成且不超过10个字</span>'
          this.navState = false
        } else {
          this.navigateNamePrv = '<span style="color: #97A8BE">不超过10个字</span>'
          this.navState = true
        }
      }
    },
    url (Val) {
      if (Val) {
        const atn = pattern.url
        let flag = atn.test(Val)
        if (!flag) {
          this.urlPrv = '<span style="color: red">请输入正确的URL格式</span>'
          this.navState = false
        } else {
          this.urlPrv = '<span style="color: #97A8BE">不超过256个字</span>'
          this.navState = true
        }
      }
    }
  }
}
</script>

<style scoped>
  .wiscard {
    overflow: hidden;
  }

  .card_left {
    min-width: 300px;
    min-height: 602px;
    float: left;
    margin: 10px 20px 0 30px;
    background-image: url("../../../../assets/iphoneX.png");
    background-size: 100% 100%;
    position: relative;
  }

  .card_left p {
    width: 230px;
    border: 1px solid #00A0E6;
    border-radius: 5px;
    padding: 6px 0;
    display: flex;
    justify-content: space-between;
    position: absolute;
    line-height: 18px;
    color: #00A0E6;
    top: 265px;
    left: 35px;
  }

  .phonenavbar {
    width: 80%;
    display: flex;
    color: #00A0E6;
    justify-content: space-between;
    position: absolute;
    top: 40px;
    left: 25px;
  }

  .media-object {
    padding-top: 7px;
    vertical-align: super;
  }

  .top {
    width: 250px;
    height: 173px;
    display: block;
    border: 1px solid #a9a9a9;
    border-radius: 10px;
    position: absolute;
    top: 69px;
    left: 25px;
  }

  .schoolInfo {
    position: absolute;
    top: 82px;
    left: 35px;
  }

  .schoolInfo img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: middle;
  }

  .schoolInfo span {
    line-height: 25px;
    display: inline-block;
    color: #FFFFFF;
  }

  .formSet {
    width: 80%;
    position: absolute;
    left: 35px;
    top: 135px;
    color: white;
    overflow: auto;
    overflow-x: hidden;
    line-height: 30px;
  }

  .formSet li {
    line-height: 30px;
  }

  .formSet li b {
    display: inline-block;
    width: 60px;
  }

  .function {
    width: 230px;
    position: absolute;
    left: 35px;
    top: 315px;
    height: 220px;
    overflow: auto;
    overflow-x: hidden;
    line-height: 30px;
  }

  .function::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .function::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #535353;
  }
  .function::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
  }

  .function .title {
    line-height: 20px;
    font-size: 14px;
    padding-left: 5px;
    margin-bottom: 5px;
    border-left: 3px solid #00A0E6;
  }

  .function ul {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .function li {
    width: 25%;
    height: 60px;
  }

  .function li img {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0 auto;
  }

  .function li span {
    display: block;
    width: 100%;
    font-size: 10px;
    line-height: 24px;
    color: #AEAEAE;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }

  .card_right {
    float: left;
    margin: 10px 20px 0 30px;
  }

  .step {
    overflow: hidden;
    color: #48576A;
    padding-bottom: 3px;
    border-bottom: 1px solid #E6EBF2;
  }

  .step > div {
    width: 206px;
    height: 54px;
    float: left;
    text-align: center;
    font-size: 20px;
    line-height: 52px;
    background-color: #EFF1F5;
    border: 2px solid white;
    position: relative;
  }

  .step .step_on {
    background-color: #00A0E6;
    color: white;
  }

  .contentS .trans {
    background-color: #EFF1F5;
  }

  .trans {
    width: 38px;
    height: 38px;
    background-color: #00A0E6;
    border-top: 2px solid white;
    border-right: 2px solid white;
    position: absolute;
    right: -22px;
    top: 6px;
    z-index: 2;
    transform: rotate(45deg);
  }

  .trans2 {
    width: 38px;
    height: 38px;
    background-color: #EFF1F5;
    border-top: 2px solid white;
    border-right: 2px solid white;
    position: absolute;
    right: -22px;
    top: 6px;
    z-index: 2;
    transform: rotate(45deg);
  }

  .media {
    width: 600px;
    height: 58px;
    line-height: 58px;
    background-color: #EFF1F5;
    margin: 10px auto;
  }

  .media-left {
    padding: 10px;
  }

  .media-body {
    color: #00A0E6;
    vertical-align: middle;
  }

  .media-body span {
    color: #666666;
  }

  .content {
    width: 600px;
    border: 1px solid #E6EBF2;
    margin: 10px auto;
  }

  .content h6 {
    padding-left: 10px;
    line-height: 30px;
    background-color: #EFF1F5;
    margin: 0;
    font-size: 14px;
  }

  .content > div {
    color: #48576A;
    width: 80%;
    margin: 0 auto;
    padding: 10px 0;
  }

  .content > div > div {
    display: flex;
    justify-content: space-between;
  }

  .content a {
    margin-bottom: 5px;
    display: block;
    width: 328px;
    height: 201px;
  }

  #cardbg {
    width: 300px;
    height: 170px;
    border: dashed 1px #D7D7D7;
    position: relative;
  }

  #cardbg b {
    font-size: 40px;
    color: #97A8BE;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    text-align: center;
    display: block;
  }

  #cardbg p {
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
  }

  .content p {
    width: 328px;
    font-size: 12px;
    color: #97A8BE;
  }

  .content > p {
    width: 100%;
    margin: 0;
    border-top: 1px solid #E6EBF2;
  }

  #payment,
  #control,
  #supportFrontText {
    vertical-align: text-bottom;
    margin-right: 5px;
  }

  label {
    color: #48576A;
    font-weight: 400;
  }

  .next {
    width: 102px;
    height: 30px;
    color: white;
    background-color: #00A0E6;
    display: block;
    margin: 20px auto;
    line-height: 30px;
    border-radius: 5px;
    text-align: center;
    border: 0;
  }

  .next:hover {
    background: #06B3FF;
    color: #FFFFFF;
    cursor: pointer;
  }

  .contentB {
    width: 600px;
    border: 1px solid #E6EBF2;
    margin: 10px auto;
  }

  .contentB h6 {
    font-size: 14px;
    padding-left: 10px;
    line-height: 30px;
    background-color: #EFF1F5;
    margin: 0;
    border-bottom: 1px solid #E6EBF2;
    display: flex;
    justify-content: space-between;
  }

  .contentB h6 a {
    height: 24px;
    margin-right: 10px;
    color: #00A0E6;
  }

  .contentB > div > div > a {
    display: block;
    width: 328px;
    height: 201px;
  }

  .column_img {
    width: 128px;
    margin: 0 20px;
    position: relative;
  }

  .contentB .upConfigIcon {
    width: 100px;
    height: 100px;
    color: #bbbbbb;
    vertical-align: center;
    border-radius: 5px;
    border: 1px dashed #00A0E6;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: translateY(-50%);
  }

  .contentB .upConfigIcon:hover {
    color: #00A0E6;
    cursor: pointer;
  }

  .upConfigIcon img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .upConfigIcon b {
    display: block;
    text-align: center;
    font-size: 32px;
    line-height: 80px;
  }

  .upConfigIcon p {
    font-size: 12px;
    text-align: center;
  }

  .column {
    display: flex;
    justify-content: flex-start;
  }

  .column_text > p {
    margin: 20px 0;
  }

  .column_text > p strong {
    color: red;
    width: 10px;
    display: inline-block;
  }

  #nav_name,
  #nav_info,
  #nav_url {
    width: 262px;
    height: 28px;
    border: 1px solid #D7D7D7;
    margin-left: 15px;
    padding: 0 8px;
  }

  .column_text > p > span {
    color: #97A8BE;
    display: block;
    font-size: 12px;
    margin-left: 10px;
  }

  label {
    color: #333333;
    font-weight: 400;
  }

  .ope {
    width: 45%;
    margin: 20px auto;
  }

  .add {
    width: 102px;
    height: 30px;
    color: #48576A;
    background-color: #F7F7F7;
    border: 1px solid #D7D7D7;
    margin-right: 20px;
    border-radius: 5px;
    text-align: center;
  }

  .nextB {
    width: 102px;
    height: 30px;
    color: white;
    background-color: #00A0E6;
    border-radius: 5px;
    text-align: center;
    border: 0;
  }

  .nextB:hover {
    background: #06B3FF;
    cursor: pointer;
  }

  .add:hover {
    color: #00A0E6;
    border: 1px solid #00A0E6;
  }

  .ope a {
    display: inline-block;
  }

  .contentS {
    width: 600px;
    border: 1px solid #E6EBF2;
    margin: 10px auto;
  }

  .contentS h6 {
    font-size: 14px;
    padding-left: 10px;
    line-height: 30px;
    background-color: #EFF1F5;
    margin: 0;
    border-bottom: 1px solid #E6EBF2;
  }

  .contentS > p {
    width: 70%;
    margin: 20px auto;
  }

  .contentS > p strong {
    color: red;
    width: 10px;
    display: inline-block;
  }

  .contentS ul {
    width: 60%;
    margin: 20px auto;
    overflow: hidden;
  }

  .contentS ul li {
    width: 50%;
    padding: 10px 0;
    float: left;
  }

  #nav_name,
  #nav_info,
  #nav_url {
    width: 262px;
    height: 28px;
    border: 1px solid #D7D7D7;
    margin-left: 15px;
    border-radius: 4px;
  }

  .contentS > p > span {
    color: #97A8BE;
    display: block;
    margin-left: 80px;
  }

  label {
    color: #333333;
    font-weight: 400;
  }

  .save {
    width: 150px;
    height: 36px;
    color: white;
    background-color: #00A0E6;
    display: block;
    margin: 20px auto;
    border-radius: 5px;
    text-align: center;
    border: 0;
    line-height: 36px;
  }

  .save:hover {
    background: #06B3FF;
    color: #FFFFFF;
    cursor: pointer;
  }

  #creatCode {
    display: block;
    width: 150px !important;
    height: 150px !important;
    margin: 0 auto;
    position: relative;
  }

</style>

<style lang="less">
  .navCheckBox {
    .el-checkbox {
      width: 25%;
      margin-left: 0!important;
      margin-right: 0!important;
    }
  }
  .cardTypeBox {
    margin: 20px 0;
    display: flex;
    font-size: 14px;
    justify-content: flex-start;
    .cardTypeTitle {
      line-height: 30px;
    }
    .el-select {
      width: 200px;
      line-height: 34px !important;
      margin: 0 8px 0 5px;

      .el-input__inner {
        color: #48576a!important;
        padding: 0 5px 0 10px!important;
        height: 30px!important;
        border-radius: 5px!important;
      }
    }
    .cardTypeTip {
      line-height: 30px;
      color: #bbbbbb;
    }
  }
  .wiscard {
    text-align: left;
    .categorySelect {
      display: inline-block;
      width: 262px;
      height: 28px;
      line-height: 28px;
      margin-left: 10px;
      .el-input__inner {
        padding: 0 8px;
        height: 28px;
        border: 1px solid #D7D7D7;
      }
    }
  }
  .media {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigCard/ConfigCardWx.vue